<template>
    <div class="dispending-actions">
        <div class="dispending-actions-wrap">
            <h3>{{ t('patients::dispensing.page.title.dispensing_stages') }}</h3>
            <v-btn
                v-if="canCancelSchedule"
                :disabled="readOnlyRules"
                color="primary"
                small
                rounded
                outlined
                @click="cancelScheduleDialog = true"
            >
                {{ t('patients::dispensing.button.cancel_schedule') }}
            </v-btn>
            <v-btn
                v-if="canTreatmentBreak"
                :disabled="readOnlyRules"
                color="primary"
                small
                rounded
                outlined
                @click="treatmentBreakDialog = true"
            >
                {{ t('patients::dispensing.button.treatment_break') }}
            </v-btn>
            <v-btn
                v-if="canStopDispensing"
                :disabled="readOnlyRules"
                color="primary"
                small
                rounded
                outlined
                @click="stopDispensingDialog = true"
            >
                {{ t('patients::dispensing.button.stop_dispensing') }}
            </v-btn>
        </div>
        <div>
            <v-dialog v-model="treatmentBreakDialog" width="500" @click:outside="$refs.treatmentBreakForm.reset()">
                <v-card>
                    <v-card-title>{{ t('patients::dispensing.modal.title.treatment_break') }}</v-card-title>
                    <v-card-text>
                        <v-form ref="treatmentBreakForm" v-model="treatmentBreakForm" :disabled="readOnlyRules">
                            <b-date-picker-store
                                to-mutate="patients::dispensingForm.input_date"
                                :label="t('patients::dispensing.form.label.input_date')"
                                :rules="validationRules.treatmentBreakForm.input_date"
                                mandatory
                            ></b-date-picker-store>
                            <b-textarea
                                rows="2"
                                to-mutate="patients::dispensingForm.reason"
                                :label="t('patients::dispensing.form.label.reason')"
                                :rules="validationRules.treatmentBreakForm.reason"
                                mandatory
                            ></b-textarea>
                            <b-alert
                                v-if="treatmentBreakDurationWarning"
                                type="warning"
                                :message="t('patients::dispensing.warning.treatment_break_duration_more_than_4_weeks')"
                                :has-content="false"
                                :has-header-button="false"
                                :dismissible="false"
                            >
                            </b-alert>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" outlined rounded :disabled="!treatmentBreakForm" @click="treatmentBreak"
                            >{{ t('patients::button.save') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="stopDispensingDialog" width="500" @click:outside="$refs.stopDispensingForm.reset()">
                <v-card>
                    <v-card-title>{{ t('patients::dispensing.modal.title.stop_dispensing') }}</v-card-title>
                    <v-card-text>
                        <v-form ref="stopDispensingForm" v-model="stopDispensingForm" :disabled="readOnlyRules">
                            <b-date-picker-store
                                to-mutate="patients::dispensingForm.blood_result_date"
                                :label="t('patients::dispensing.form.label.blood_result_date')"
                                :rules="validationRules.stopDispensingForm.blood_result_date"
                                mandatory
                            ></b-date-picker-store>
                            <b-textarea
                                rows="2"
                                to-mutate="patients::dispensingForm.reason"
                                :label="t('patients::dispensing.form.label.reason')"
                                :rules="validationRules.stopDispensingForm.reason"
                                mandatory
                            ></b-textarea>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" outlined rounded :disabled="!stopDispensingForm" @click="stopDispensing"
                            >{{ t('patients::button.save') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="cancelScheduleDialog" width="500" @click:outside="$refs.cancelScheduleForm.reset()">
                <v-card>
                    <v-card-title>{{ t('patients::dispensing.modal.title.cancel_schedule') }}</v-card-title>
                    <v-card-text>
                        <v-form ref="cancelScheduleForm" v-model="cancelScheduleForm" :disabled="readOnlyRules">
                            <b-date-picker-store
                                to-mutate="patients::dispensingForm.input_date"
                                :label="t('patients::dispensing.form.label.input_date')"
                                :rules="validationRules.cancelScheduleForm.input_date"
                                mandatory
                            ></b-date-picker-store>
                            <b-textarea
                                rows="2"
                                to-mutate="patients::dispensingForm.reason"
                                :label="t('patients::dispensing.form.label.reason')"
                                :rules="validationRules.cancelScheduleForm.reason"
                                mandatory
                            ></b-textarea>
                            <b-switch
                                to-mutate="patients::dispensingForm.dispensing_stopped"
                                :label="t('patients::dispensing.form.label.dispensing_stopped')"
                                :rules="validationRules.cancelScheduleForm.dispensing_stopped"
                                reverse
                            ></b-switch>
                            <b-textarea
                                rows="2"
                                to-mutate="patients::dispensingForm.dispensing_stopped_reason"
                                :label="t('patients::dispensing.form.label.dispensing_stopped_reason')"
                                :rules="dispensingStoppedReason"
                                mandatory
                            ></b-textarea>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" outlined rounded :disabled="!cancelScheduleForm" @click="cancelSchedule"
                            >{{ t('patients::button.save') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
//TODO make it defult import
import { FakeTimeLineElement } from '../../../app';

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            stopDispensingForm: false,
            cancelScheduleForm: false,
            treatmentBreakForm: false,
            stopDispensingDialog: false,
            cancelScheduleDialog: false,
            treatmentBreakDialog: false,
            validationRules: {
                stopDispensingForm: {
                    blood_result_date: [(v) => !!v || t('users::validation.field.required')],
                    reason: [(v) => !!v || t('users::validation.field.required')],
                },
                cancelScheduleForm: {
                    input_date: [(v) => !!v || t('users::validation.field.required')],
                    reason: [(v) => !!v || t('users::validation.field.required')],
                    dispensing_permitted_reason: [(v) => !!v || t('users::validation.field.required')],
                    dispensing_stopped: [],
                    dispensing_stopped_reason: [],
                },
                treatmentBreakForm: {
                    input_date: [(v) => !!v || t('users::validation.field.required')],
                    reason: [(v) => !!v || t('users::validation.field.required')],
                },
            },
        };
    },
    computed: {
        readOnlyRules() {
            return this.disabled || !this.$store.state.patients.patient.is_registered;
        },
        patientId() {
            return this.$store.state.patients.patient.id;
        },
        dispensing() {
            return this.$store.state.patients.patient.dispensing;
        },
        treatmentBreakDurationWarning() {
            if (!this.$store.state.patients.dispensingForm.input_date) {
                return false;
            }
            let inputDate = new Date(this.$store.state.patients.dispensingForm.input_date);
            let fourWeeksAgo = new Date();
            fourWeeksAgo.setDate(fourWeeksAgo.getDate() - 28);
            return inputDate < fourWeeksAgo;
        },
        dispensingStoppedReason() {
            if (this.$store.state.patients.dispensingForm.dispensing_stopped) {
                return [(v) => !!v || t('users::validation.field.required')];
            }
            return [];
        },
        dispensingForm() {
            return this.$store.state.patients.dispensingForm;
        },
        canFillAdverseEvent() {
            const can = !!this.$store.state.patients.patient.dispensing.adverse_event_id;
            const access = this.can('api.v1.patients.adverse-events.update');
            if (can && access) {
                // const adverseEvent = FakeTimeLineElement;
                // adverseEvent.id = 'new';
                // adverseEvent.additional_data.type = 'fill-adverse-event';
                // adverseEvent.timeline_position = 'current';
                this.$store.dispatch('patients/addPatientDispensingTimelineItemFillAe');
                // _.delay(() => this.$store.dispatch('patients/setDispensingLoading', false), 100, 'later');
            }
            return can && access;
        },
        canDispensedDays() {
            const can =
                !!this.dispensing.permitted && this.dispensing.has_schedule && !this.dispensing.has_treatment_break;
            const access = this.can('api.v1.patients.dispensing-days.dispensed');
            const timeLine = this.$store.state.patients.patient.dispensing.timeLine;
            let hasNumberOfDays = false;

            if (timeLine) {
                hasNumberOfDays = timeLine.find((x) => x.additional_data.type === 'new-number-of-days');
            }

            if (can && !hasNumberOfDays && access) {
                // this.$store.dispatch('patients/setDispensingLoading', true);
                const numberOfDays = FakeTimeLineElement;
                numberOfDays.id = 'new';
                numberOfDays.additional_data.type = 'new-number-of-days';
                numberOfDays.timeline_position = 'current';
                this.$store.dispatch('patients/addPatientDispensingTimelineItem', {
                    on: 'current',
                    item: _.clone(numberOfDays),
                });
                // _.delay(() => this.$store.dispatch('patients/setDispensingLoading', false), 100, 'later');
            }
            return can && access;
        },
        canTreatmentBreak() {
            const can =
                !!this.dispensing.permitted && this.dispensing.has_schedule && !this.dispensing.has_treatment_break;
            const access = this.can('api.v1.patients.dispensing-treatment-breaks.store');
            return can && access;
        },
        canCancelSchedule() {
            const can = !!this.dispensing.permitted && this.dispensing.has_schedule;
            const access = this.can('api.v1.patients.dispensing-schedule-cancels.store');
            return can && access;
        },
        canStopDispensing() {
            const can = !!this.dispensing.permitted;
            const access = this.can('api.v1.patients.dispensing-stages.stop');
            return can && access;
        },
        canAddSchedule() {
            const can = !!this.dispensing.permitted && !this.dispensing.has_schedule;
            const access = this.can('api.v1.patients.dispensing-schedules.store');
            const timeLine = this.$store.state.patients.patient.dispensing.timeLine;
            let hasScheduleItem = false;

            if (timeLine) {
                hasScheduleItem = timeLine.find((x) => x.additional_data.type === 'new-schedule');
            }

            if (can && !hasScheduleItem && access) {
                // this.$store.dispatch('patients/setDispensingLoading', true);
                const scheduleItem = FakeTimeLineElement;
                scheduleItem.id = 'new';
                scheduleItem.additional_data.type = 'new-schedule';
                scheduleItem.timeline_position = 'current';
                this.$store.dispatch('patients/addPatientDispensingTimelineItem', {
                    on: 'current',
                    item: _.clone(scheduleItem),
                });
                // _.delay(() => this.$store.dispatch('patients/setDispensingLoading', false), 100, 'later');
            }
            return can;
        },
        canAddScheduleRestart() {
            const can = !!this.dispensing.permitted && this.dispensing.has_treatment_break;
            const access = this.can('api.v1.patients.dispensing-schedule-restarts.store');
            const timeLine = this.$store.state.patients.patient.dispensing.timeLine;
            let hasScheduleRestart = false;
            if (timeLine) {
                hasScheduleRestart = timeLine.find((x) => x.additional_data.type === 'restart-schedule');
            }

            if (can && !hasScheduleRestart && access) {
                // this.$store.dispatch('patients/setDispensingLoading', true);
                const scheduleRestart = FakeTimeLineElement;
                scheduleRestart.id = 'new';
                scheduleRestart.additional_data.type = 'restart-schedule';
                scheduleRestart.timeline_position = 'current';
                this.$store.dispatch('patients/addPatientDispensingTimelineItem', {
                    on: 'current',
                    item: _.clone(scheduleRestart),
                });
                // _.delay(() => this.$store.dispatch('patients/setDispensingLoading', false), 100, 'later');
            }
            return can;
        },
    },
    watch: {
        dispensing() {
            this.checkState();
        },
    },
    created() {},
    mounted() {
        this.checkState();
    },
    methods: {
        checkState() {
            _.delay(
                () => {
                    this.canAddSchedule;
                },
                300,
                'later'
            );
            _.delay(
                () => {
                    this.canAddScheduleRestart;
                },
                311,
                'later'
            );
            _.delay(
                () => {
                    this.canDispensedDays;
                },
                321,
                'later'
            );
            _.delay(
                () => {
                    this.canFillAdverseEvent;
                },
                302,
                'later'
            );
        },
        clearTreatmentBreakForm(formReference) {
            //clear treatmentBreakForm form
            this.$refs[formReference].reset();
        },
        cancelSchedule() {
            // this.$store.dispatch('patients/setDispensingLoading', true);
            return axios
                .post(
                    route('api.v1.patients.dispensing-schedule-cancels.store', {
                        patient: this.patientId,
                    }),
                    {
                        input_date: this.dispensingForm.input_date,
                        reason: this.dispensingForm.reason,
                        dispensing_stopped: this.dispensingForm.dispensing_stopped,
                        dispensing_stopped_reason: this.dispensingForm.dispensing_stopped_reason,
                    }
                )
                .then(() => {
                    this.stopDispensingDialog = false;
                    this.cancelScheduleDialog = false;
                    this.treatmentBreakDialog = false;
                    this.$store.dispatch('patients/resetDispensingForm');
                })
                .catch((error) => {
                    this.$store.dispatch('patients/setDispensingLoading', false);
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('patients/setErrorMessages', {
                            isDispensingForm: true,
                            errors: error.response.data.errors,
                        });
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => {
                    // this.$store.dispatch('patients/setDispensingLoading', false);
                });
        },
        stopDispensing() {
            // this.$store.dispatch('patients/setDispensingLoading', true);
            return axios
                .post(
                    route('api.v1.patients.dispensing-stages.stop', {
                        patient: this.patientId,
                    }),
                    {
                        blood_result_date: this.dispensingForm.blood_result_date,
                        reason: this.dispensingForm.reason,
                        from_ui: true,
                    }
                )
                .then(() => {
                    this.stopDispensingDialog = false;
                    this.cancelScheduleDialog = false;
                    this.treatmentBreakDialog = false;
                    this.$store.dispatch('patients/resetDispensingForm');
                })
                .catch((error) => {
                    this.$store.dispatch('patients/setDispensingLoading', false);
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('patients/setErrorMessages', {
                            isDispensingForm: true,
                            errors: error.response.data.errors,
                        });
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => {
                    // this.$store.dispatch('patients/setDispensingLoading', false);
                });
        },
        treatmentBreak() {
            // this.$store.dispatch('patients/setDispensingLoading', true);
            return axios
                .post(
                    route('api.v1.patients.dispensing-treatment-breaks.store', {
                        patient: this.patientId,
                    }),
                    {
                        input_date: this.dispensingForm.input_date,
                        reason: this.dispensingForm.reason,
                    }
                )
                .then(() => {
                    this.$store.dispatch('patients/resetDispensingForm');
                    this.stopDispensingDialog = false;
                    this.cancelScheduleDialog = false;
                    this.treatmentBreakDialog = false;
                })
                .catch((error) => {
                    this.$store.dispatch('patients/setDispensingLoading', false);
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('patients/setErrorMessages', {
                            isDispensingForm: true,
                            errors: error.response.data.errors,
                        });
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => {
                    // this.$store.dispatch('patients/setDispensingLoading', false);
                });
        },
    },
};
</script>
